import { render, staticRenderFns } from "./EducationRepeater.vue?vue&type=template&id=7fff012b&scoped=true&"
import script from "./EducationRepeater.vue?vue&type=script&lang=js&"
export * from "./EducationRepeater.vue?vue&type=script&lang=js&"
import style0 from "./EducationRepeater.vue?vue&type=style&index=0&id=7fff012b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fff012b",
  null
  
)

export default component.exports